import React from "react";

function ProIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 0C26.6274 0 32 5.37258 32 12V20C32 26.6274 26.6274 32 20 32H12C5.37258 32 0 26.6274 0 20V12C0 5.37258 5.37258 0 12 0H20Z"
        fill="#EAECF0"
      />
      <path
        d="M20 0C26.6274 0 32 5.37258 32 12V20C32 26.6274 26.6274 32 20 32H12C5.37258 32 0 26.6274 0 20V12C0 5.37258 5.37258 0 12 0H20Z"
        stroke="#667085"
      />
      <path
        d="M8.1001 20.2591C6.6001 21.5191 6.1001 25.2591 6.1001 25.2591C6.1001 25.2591 9.8401 24.7591 11.1001 23.2591C11.8101 22.4191 11.8001 21.1291 11.0101 20.3491C10.6214 19.9781 10.1094 19.7637 9.57232 19.7471C9.03526 19.7305 8.51097 19.9128 8.1001 20.2591Z"
        stroke="#667085"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6001 18.7581L12.6001 15.7581C13.1322 14.3775 13.8023 13.0541 14.6001 11.8081C15.7653 9.94505 17.3877 8.41111 19.3131 7.35215C21.2385 6.29319 23.4028 5.74443 25.6001 5.75806C25.6001 8.47806 24.8201 13.2581 19.6001 16.7581C18.337 17.5568 16.9969 18.2268 15.6001 18.7581Z"
        stroke="#667085"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6001 15.7573H7.6001C7.6001 15.7573 8.1501 12.7273 9.6001 11.7573C11.2201 10.6773 14.6001 11.7573 14.6001 11.7573"
        stroke="#667085"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6001 18.7578V23.7578C15.6001 23.7578 18.6301 23.2078 19.6001 21.7578C20.6801 20.1378 19.6001 16.7578 19.6001 16.7578"
        stroke="#667085"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ProIcon;
